import React from 'react';
import { IoMdClose } from 'react-icons/io';

interface SideDrawerProps {
    open: boolean;
    title: string;
    subtitle?: string;
    width?: string;
    onClose: () => void;
    footer?: React.ReactNode;
    headerActions?: React.ReactNode;
    titleAccessory?: React.ReactNode;
    children: React.ReactNode;
}

// Painel lateral que desliza da direita. Usado para a view/edição rápida a
// partir das listas (clique na linha).
const SideDrawer: React.FC<SideDrawerProps> = ({
    open,
    title,
    subtitle,
    width = '460px',
    onClose,
    footer,
    headerActions,
    titleAccessory,
    children,
}) => (
    <>
        <div
            className={`fixed inset-0 bg-black/40 z-[9998] transition-opacity ${
                open ? 'opacity-100' : 'opacity-0 pointer-events-none'
            }`}
            onClick={onClose}
        />
        <aside
            className={`fixed top-0 right-0 h-full bg-white dark:bg-slate-800 shadow-2xl z-[9999] flex flex-col transition-transform duration-200 ${
                open ? 'translate-x-0' : 'translate-x-full'
            }`}
            style={{ width, maxWidth: '95vw' }}
            aria-hidden={!open}
        >
            {open && (
                <button
                    type="button"
                    className="absolute -left-4 top-5 z-[10000] w-8 h-8 rounded-full bg-white dark:bg-slate-700 shadow-md border border-gray-200 dark:border-slate-600 text-gray-900 hover:bg-gray-200 dark:text-white dark:hover:bg-gray-600 flex items-center justify-center"
                    onClick={onClose}
                    aria-label="Fechar"
                >
                    <IoMdClose size={20} />
                </button>
            )}
            <div className="flex items-start justify-between px-5 py-3 border-b border-gray-200 dark:border-slate-700">
                <div>
                    <div className="flex items-center gap-2">
                        <h3 className="text-base font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
                        {titleAccessory}
                    </div>
                    {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
                </div>
                {headerActions && <div className="flex items-center gap-2 shrink-0">{headerActions}</div>}
            </div>
            <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
            {footer && (
                <div className="px-5 py-3 border-t border-gray-200 dark:border-slate-700 flex justify-end gap-3">
                    {footer}
                </div>
            )}
        </aside>
    </>
);

export default SideDrawer;
